import React, { useState } from "react";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import CancelIcon from "@mui/icons-material/Cancel";
import baseUrl from "../../../../api/baseUrl";
import { toast } from "react-toastify";

function ReScheduleTray({ data, setSelectReSchedule, onCancel }: any) {
  const [select, setselect] = useState("");

  const handleSelect = (e: any) => {
    setSelectReSchedule(e);
    setselect(e);
  };

  const handleCancelAppointment = async (e: React.MouseEvent, appointmentId: string) => {
    e.stopPropagation(); // Prevent triggering the select handler
    
    try {
      const response = await baseUrl.patch(
        "/appointment/statusAppointmentById",
        {},
        {
          headers: {
            appointmentid: appointmentId,
            status: "canceled",
          },
        }
      );
      
      if (response.data?.success) {
        toast.success("Appointment canceled successfully!");
        // Clear selection if the canceled item was selected
        if (select === appointmentId) {
          setSelectReSchedule("");
          setselect("");
        }
        // Refresh the tray data
        if (onCancel) {
          onCancel();
        }
      } else {
        toast.error("Failed to cancel appointment");
      }
    } catch (error: any) {
      console.error("Error canceling appointment:", error);
      toast.error(error?.response?.data?.message || "Failed to cancel appointment");
    }
  };

  return (
    <div className="border-b border-slate-200">
      {/* Header */}
      <div className="bg-amber-500 px-4 py-2 flex items-center gap-2">
        <EventRepeatIcon className="text-white" sx={{ fontSize: 18 }} />
        <h5 className="text-white font-semibold text-sm uppercase">Reschedule Tray</h5>
      </div>

      {/* Patient List */}
      <div className="p-3 pb-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 max-h-[200px] overflow-y-auto">
          {data?.map((item: any, i: number) => (
            <div
              key={i}
              onClick={() => handleSelect(item?._id)}
              className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all ${
                select === item?._id
                  ? "bg-amber-100 border-2 border-amber-400"
                  : "bg-slate-50 border border-slate-200 hover:bg-slate-100"
              }`}
            >
              <div className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold ${
                    select === item?._id
                      ? "bg-amber-500 text-white"
                      : "bg-slate-200 text-slate-600"
                  }`}
                >
                  {item?.patientId?.fullName?.charAt(0)?.toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-800">
                    {item?.patientId?.fullName}
                  </p>
                  <p className="text-xs text-slate-500">{item?.patientId?.regNo}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {select === item?._id && (
                  <CheckCircleIcon className="text-amber-500" sx={{ fontSize: 18 }} />
                )}
                <button
                  onClick={(e) => handleCancelAppointment(e, item?._id)}
                  className="w-6 h-6 flex items-center justify-center rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition-colors"
                  title="Cancel Appointment"
                >
                  <CancelIcon sx={{ fontSize: 14 }} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Deselect Button - at bottom */}
        {select && (
          <div className="pt-2 mt-2 border-t border-slate-200">
            <button
              onClick={() => handleSelect("")}
              className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-slate-100 text-slate-600 rounded-lg hover:bg-slate-200 transition-colors text-sm font-medium"
            >
              <ClearIcon sx={{ fontSize: 16 }} />
              Deselect
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReScheduleTray;
